import axiosInstance from './axiosInstance';
import { Permission } from '../models/Permission';
import { ModulesPermissions } from '../models/ModulesPermissions';

const getPermissions = async function (
  serviceBaseUrl: string,
  ocpApimKey: string,
  permissionCategory: 'Functional' | 'LocalData' = 'Functional'
) {
  const url = `${serviceBaseUrl}/user-permissions/current?permissionCategory=${permissionCategory}`;

  const options = {
    baseURL: url,
    headers: {
      'Ocp-Apim-Subscription-Key': ocpApimKey,
    },
  };

  const response = await axiosInstance.get<Permission[]>(
    encodeURI(url),
    options
  );
  return response.data;
};

const getModulesPermissions = async (
  serviceBaseUrl: string,
  ocpApimKey: string,
  moduleKeys: string[],
  permissionCategory: 'Functional' | 'LocalData' = 'Functional'
): Promise<ModulesPermissions> => {
  let moduleKeyParam = '';
  moduleKeys.forEach((x) => (moduleKeyParam += `&moduleKeys=${x}`));
  const url = `${serviceBaseUrl}/user-permissions/current/modules?permissionCategory=${permissionCategory}${moduleKeyParam}`;

  const options = {
    baseURL: url,
    headers: {
      'Ocp-Apim-Subscription-Key': ocpApimKey,
    },
  };

  const { data } = await axiosInstance.get<ModulesPermissions>(
    encodeURI(url),
    options
  );
  return data;
};

export { getPermissions, getModulesPermissions };
